import type { TicketDetailDto } from "@megaron/support-contracts";

export function isSupportTicketFromEmailMailbox(ticket: TicketDetailDto): boolean {
  if (ticket.threadId) return true;
  return ticket.messages.some((message) => {
    const imapMsgId = message.imapMsgId?.trim();
    return imapMsgId != null && imapMsgId.length > 0;
  });
}

export function getSupportTicketMessagesSectionTitle(ticket: TicketDetailDto): string {
  return isSupportTicketFromEmailMailbox(ticket) ? "Wiadomości email" : "Treść";
}
